// extracted by mini-css-extract-plugin
export var active = "TournamentFilter-module--active--d7a97";
export var all = "TournamentFilter-module--all--2e3fb";
export var back = "TournamentFilter-module--back--faeed";
export var blue = "#0eb3f2";
export var clear = "TournamentFilter-module--clear--0fbec";
export var dialogFooter = "TournamentFilter-module--dialogFooter--73745";
export var dialogHeader = "TournamentFilter-module--dialogHeader--a1ee8";
export var dialogInput = "TournamentFilter-module--dialogInput--c38df";
export var dialogInputWrapper = "TournamentFilter-module--dialogInputWrapper--50a28";
export var dialogToggleGroup = "TournamentFilter-module--dialogToggleGroup--697f8";
export var dialogTrigger = "TournamentFilter-module--dialogTrigger--7d1e8";
export var dialogTriggerButton = "TournamentFilter-module--dialogTriggerButton--cdb50";
export var emphasis = "TournamentFilter-module--emphasis--7520e";
export var filterButton = "TournamentFilter-module--filterButton--c5e9d";
export var filterIcon = "TournamentFilter-module--filterIcon--0e709";
export var footerButton = "TournamentFilter-module--footerButton--0d808";
export var footerButtonIcon = "TournamentFilter-module--footerButtonIcon--36066";
export var green = "#57d33b";
export var greenLink = "TournamentFilter-module--green-link--d0c0f";
export var grey = "var(--tone-mid)";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var titleIcon = "TournamentFilter-module--titleIcon--7f21b";
export var toggleGroup = "TournamentFilter-module--toggleGroup--ff948";
export var toggleGroupItem = "TournamentFilter-module--toggleGroupItem--fa912";
export var toggleGroupItemBase = "TournamentFilter-module--toggleGroupItemBase--9f1d5";
export var tournamentFilter = "TournamentFilter-module--tournamentFilter--36cbf";
export var tournamentFilterDialog = "TournamentFilter-module--tournamentFilterDialog--e61f9";
export var triggerArrowIcon = "TournamentFilter-module--triggerArrowIcon--590b4";
export var triggerArrowIconWrapper = "TournamentFilter-module--triggerArrowIconWrapper--9f83a";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";